var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrappedMolecule,_vm._b({tag:"component"},'component',Object.assign({}, _vm.model, _vm.common),false))}
var staticRenderFns = []

export { render, staticRenderFns }